import { Navigate, useLocation } from 'react-router-dom';
import { Spinner } from '../Spinner/Spinner';
import styles from './ProtectedRoute.module.css';
import { useAuth } from '../../../app/auth/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  scope: 'ADMIN' | 'TEACHER' | 'STUDENT';
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, scope }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className={styles.container}>
        <Spinner />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user?.role !== scope) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
